import { channelMeta } from "@/lib/constants";

export function ChannelIcon({ channel, size = 14, className = "" }) {
  const meta = channelMeta(channel);
  const Icon = meta.icon;
  return <Icon size={size} strokeWidth={1.5} className={className} aria-label={meta.label} />;
}
